import { render, staticRenderFns } from "./BlockType3Grid.vue?vue&type=template&id=86c28c3e&scoped=true"
import script from "./BlockType3Grid.vue?vue&type=script&lang=ts"
export * from "./BlockType3Grid.vue?vue&type=script&lang=ts"
import style0 from "./BlockType3Grid.vue?vue&type=style&index=0&id=86c28c3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c28c3e",
  null
  
)

export default component.exports